module.exports = {
  mkdirs: require('./mkdirs'),
  mkdirsSync: require('./mkdirs-sync'),
  // alias
  mkdirp: require('./mkdirs'),
  mkdirpSync: require('./mkdirs-sync'),
  ensureDir: require('./mkdirs'),
  ensureDirSync: require('./mkdirs-sync')
}



//////////////////
// WEBPACK FOOTER
// ./~/fs-promise/~/fs-extra/lib/mkdirs/index.js
// module id = 56
// module chunks = 0 1 2